import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';
import { vipColors } from '../../VipIcon/index.js';

const BenefitsHeader = ({
  title,
  level,
  label,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, title), /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.badge),
    style: { background: vipColors[level.toLowerCase()] }
  },
  label || level
));
BenefitsHeader.displayName = "Benefits.BenefitsHeader";

export { BenefitsHeader };
//# sourceMappingURL=index.js.map
